import { mqTabletPortrait } from './mq';

class MobileImages {
  constructor() {
    this.images = [];

    this.reinit();

    if (mqTabletPortrait.addEventListener) {
      mqTabletPortrait.addEventListener('change', (e) => this.onChange(e.matches));
    } else {
      mqTabletPortrait.addListener((e) => this.onChange(e.matches));
    }

    this.onChange(mqTabletPortrait.matches);

    window.addEventListener('init', () => {
      this.reinit();
      this.onChange(mqTabletPortrait.matches);
    });
  }

  reinit() {
    document.querySelectorAll('img[data-src]:not([data-initialized])').forEach((img) => {
      img.setAttribute('data-initialized', '1');
      this.images.push(img);
    });
  }

  onChange(matches) {
    if (matches) {
      this.setMobileImages();
    } else {
      this.setRegularImages();
    }
  }

  setRegularImages() {
    this.images.forEach((img) => {
      img.src = img.dataset.src;

      if (img.dataset.maxWidth) {
        img.style.maxWidth = img.dataset.maxWidth + '%';
      }
    });
  }

  setMobileImages() {
    this.images.forEach((img) => {
      if (img.dataset.srcMobile) {
        img.src = img.dataset.srcMobile;
      } else if (img.dataset.src) {
        img.src = img.dataset.src;
      }

      if (img.dataset.maxWidthMobile) {
        img.style.maxWidth = img.dataset.maxWidthMobile + '%';
      } else if (img.dataset.maxWidth) {
        img.style.maxWidth = img.dataset.maxWidth + '%';
      }
    });
  }
}

const mobileImages = new MobileImages();

export { mobileImages, MobileImages };